import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportGrossYieldLinkedFetch } from './actions';

export const sagasReportGrossYieldLinked = [
  takeLatest(actionReportGrossYieldLinkedFetch.rejected, workerErrorNotifyThunk),
];
